import type { ReactNode } from "react"

import NextHead from "@/common/vite-shims/next/head"

interface HeadProps {
  /** `<title>`, `<meta>`, `<link>`, `<script>` tags to merge into the document head. */
  children: ReactNode
}

/**
 * Framework-neutral document head, backed by the React Router `next/head` shim.
 * Consumers import from `@/common/head` and pass `key` on tags they expect to
 * dedupe.
 *
 * @example
 * <Head>
 *   <title>Page title</title>
 *   <meta name="description" content="..." />
 * </Head>
 */
export function Head({ children }: HeadProps) {
  return <NextHead>{children}</NextHead>
}
